export const isBreakdownValue = (value) => typeof value === 'object' && value !== null && 'breakdown' in value;
export const isValuePair = (value) => Array.isArray(value) && value.length === 2;
